// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/pulse.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.pulse";

export interface PulseEnrollment {
  companyId: number;
  frequency: PulseFrequency | undefined;
}

export interface PulseFrequency {
  daily: boolean;
  weekly: boolean;
}

export interface PulseDigestItem {
  key: string;
  type: { $case: "repo"; value: RepoDigestItem } | undefined;
}

export interface RepoDigestItem {
  repoId: string;
}

export interface PulseDigestPeriod {
  fromDate: Date | undefined;
  toDate: Date | undefined;
}

export interface PulseDigest {
  companyId: number;
  contextifyId: string;
  content: string;
  period: PulseDigestPeriod | undefined;
  items: PulseDigestItem[];
}

export interface PulseFeedItem {
  updateId: string;
  featureId: string;
  featureTitle: string;
  summary: string;
  createdAt: Date | undefined;
  featureAvailable: boolean;
}

function createBasePulseEnrollment(): PulseEnrollment {
  return { companyId: 0, frequency: undefined };
}

export const PulseEnrollment: MessageFns<PulseEnrollment> = {
  encode(message: PulseEnrollment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.frequency !== undefined) {
      PulseFrequency.encode(message.frequency, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PulseEnrollment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePulseEnrollment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.frequency = PulseFrequency.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PulseEnrollment {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      frequency: isSet(object.frequency) ? PulseFrequency.fromJSON(object.frequency) : undefined,
    };
  },

  toJSON(message: PulseEnrollment): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.frequency !== undefined) {
      obj.frequency = PulseFrequency.toJSON(message.frequency);
    }
    return obj;
  },

  create(base?: DeepPartial<PulseEnrollment>): PulseEnrollment {
    return PulseEnrollment.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PulseEnrollment>): PulseEnrollment {
    const message = createBasePulseEnrollment();
    message.companyId = object.companyId ?? 0;
    message.frequency = (object.frequency !== undefined && object.frequency !== null)
      ? PulseFrequency.fromPartial(object.frequency)
      : undefined;
    return message;
  },
};

function createBasePulseFrequency(): PulseFrequency {
  return { daily: false, weekly: false };
}

export const PulseFrequency: MessageFns<PulseFrequency> = {
  encode(message: PulseFrequency, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.daily !== false) {
      writer.uint32(8).bool(message.daily);
    }
    if (message.weekly !== false) {
      writer.uint32(16).bool(message.weekly);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PulseFrequency {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePulseFrequency();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.daily = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.weekly = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PulseFrequency {
    return {
      daily: isSet(object.daily) ? globalThis.Boolean(object.daily) : false,
      weekly: isSet(object.weekly) ? globalThis.Boolean(object.weekly) : false,
    };
  },

  toJSON(message: PulseFrequency): unknown {
    const obj: any = {};
    if (message.daily !== false) {
      obj.daily = message.daily;
    }
    if (message.weekly !== false) {
      obj.weekly = message.weekly;
    }
    return obj;
  },

  create(base?: DeepPartial<PulseFrequency>): PulseFrequency {
    return PulseFrequency.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PulseFrequency>): PulseFrequency {
    const message = createBasePulseFrequency();
    message.daily = object.daily ?? false;
    message.weekly = object.weekly ?? false;
    return message;
  },
};

function createBasePulseDigestItem(): PulseDigestItem {
  return { key: "", type: undefined };
}

export const PulseDigestItem: MessageFns<PulseDigestItem> = {
  encode(message: PulseDigestItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    switch (message.type?.$case) {
      case "repo":
        RepoDigestItem.encode(message.type.value, writer.uint32(802).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PulseDigestItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePulseDigestItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.type = { $case: "repo", value: RepoDigestItem.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PulseDigestItem {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      type: isSet(object.repo) ? { $case: "repo", value: RepoDigestItem.fromJSON(object.repo) } : undefined,
    };
  },

  toJSON(message: PulseDigestItem): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.type?.$case === "repo") {
      obj.repo = RepoDigestItem.toJSON(message.type.value);
    }
    return obj;
  },

  create(base?: DeepPartial<PulseDigestItem>): PulseDigestItem {
    return PulseDigestItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PulseDigestItem>): PulseDigestItem {
    const message = createBasePulseDigestItem();
    message.key = object.key ?? "";
    switch (object.type?.$case) {
      case "repo": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "repo", value: RepoDigestItem.fromPartial(object.type.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseRepoDigestItem(): RepoDigestItem {
  return { repoId: "" };
}

export const RepoDigestItem: MessageFns<RepoDigestItem> = {
  encode(message: RepoDigestItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.repoId !== "") {
      writer.uint32(10).string(message.repoId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoDigestItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoDigestItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.repoId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoDigestItem {
    return {
      repoId: isSet(object.repoId)
        ? globalThis.String(object.repoId)
        : isSet(object.repo_id)
        ? globalThis.String(object.repo_id)
        : "",
    };
  },

  toJSON(message: RepoDigestItem): unknown {
    const obj: any = {};
    if (message.repoId !== "") {
      obj.repoId = message.repoId;
    }
    return obj;
  },

  create(base?: DeepPartial<RepoDigestItem>): RepoDigestItem {
    return RepoDigestItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoDigestItem>): RepoDigestItem {
    const message = createBaseRepoDigestItem();
    message.repoId = object.repoId ?? "";
    return message;
  },
};

function createBasePulseDigestPeriod(): PulseDigestPeriod {
  return { fromDate: undefined, toDate: undefined };
}

export const PulseDigestPeriod: MessageFns<PulseDigestPeriod> = {
  encode(message: PulseDigestPeriod, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fromDate !== undefined) {
      Timestamp.encode(toTimestamp(message.fromDate), writer.uint32(10).fork()).join();
    }
    if (message.toDate !== undefined) {
      Timestamp.encode(toTimestamp(message.toDate), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PulseDigestPeriod {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePulseDigestPeriod();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fromDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.toDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PulseDigestPeriod {
    return {
      fromDate: isSet(object.fromDate)
        ? fromJsonTimestamp(object.fromDate)
        : isSet(object.from_date)
        ? fromJsonTimestamp(object.from_date)
        : undefined,
      toDate: isSet(object.toDate)
        ? fromJsonTimestamp(object.toDate)
        : isSet(object.to_date)
        ? fromJsonTimestamp(object.to_date)
        : undefined,
    };
  },

  toJSON(message: PulseDigestPeriod): unknown {
    const obj: any = {};
    if (message.fromDate !== undefined) {
      obj.fromDate = message.fromDate.toISOString();
    }
    if (message.toDate !== undefined) {
      obj.toDate = message.toDate.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<PulseDigestPeriod>): PulseDigestPeriod {
    return PulseDigestPeriod.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PulseDigestPeriod>): PulseDigestPeriod {
    const message = createBasePulseDigestPeriod();
    message.fromDate = object.fromDate ?? undefined;
    message.toDate = object.toDate ?? undefined;
    return message;
  },
};

function createBasePulseDigest(): PulseDigest {
  return { companyId: 0, contextifyId: "", content: "", period: undefined, items: [] };
}

export const PulseDigest: MessageFns<PulseDigest> = {
  encode(message: PulseDigest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.contextifyId !== "") {
      writer.uint32(18).string(message.contextifyId);
    }
    if (message.content !== "") {
      writer.uint32(26).string(message.content);
    }
    if (message.period !== undefined) {
      PulseDigestPeriod.encode(message.period, writer.uint32(34).fork()).join();
    }
    for (const v of message.items) {
      PulseDigestItem.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PulseDigest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePulseDigest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.contextifyId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.period = PulseDigestPeriod.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.items.push(PulseDigestItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PulseDigest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      contextifyId: isSet(object.contextifyId)
        ? globalThis.String(object.contextifyId)
        : isSet(object.contextify_id)
        ? globalThis.String(object.contextify_id)
        : "",
      content: isSet(object.content) ? globalThis.String(object.content) : "",
      period: isSet(object.period) ? PulseDigestPeriod.fromJSON(object.period) : undefined,
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => PulseDigestItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: PulseDigest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.contextifyId !== "") {
      obj.contextifyId = message.contextifyId;
    }
    if (message.content !== "") {
      obj.content = message.content;
    }
    if (message.period !== undefined) {
      obj.period = PulseDigestPeriod.toJSON(message.period);
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => PulseDigestItem.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<PulseDigest>): PulseDigest {
    return PulseDigest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PulseDigest>): PulseDigest {
    const message = createBasePulseDigest();
    message.companyId = object.companyId ?? 0;
    message.contextifyId = object.contextifyId ?? "";
    message.content = object.content ?? "";
    message.period = (object.period !== undefined && object.period !== null)
      ? PulseDigestPeriod.fromPartial(object.period)
      : undefined;
    message.items = object.items?.map((e) => PulseDigestItem.fromPartial(e)) || [];
    return message;
  },
};

function createBasePulseFeedItem(): PulseFeedItem {
  return { updateId: "", featureId: "", featureTitle: "", summary: "", createdAt: undefined, featureAvailable: false };
}

export const PulseFeedItem: MessageFns<PulseFeedItem> = {
  encode(message: PulseFeedItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.updateId !== "") {
      writer.uint32(10).string(message.updateId);
    }
    if (message.featureId !== "") {
      writer.uint32(18).string(message.featureId);
    }
    if (message.featureTitle !== "") {
      writer.uint32(26).string(message.featureTitle);
    }
    if (message.summary !== "") {
      writer.uint32(34).string(message.summary);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.featureAvailable !== false) {
      writer.uint32(48).bool(message.featureAvailable);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PulseFeedItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePulseFeedItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.updateId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.featureId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.featureTitle = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.featureAvailable = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PulseFeedItem {
    return {
      updateId: isSet(object.updateId)
        ? globalThis.String(object.updateId)
        : isSet(object.update_id)
        ? globalThis.String(object.update_id)
        : "",
      featureId: isSet(object.featureId)
        ? globalThis.String(object.featureId)
        : isSet(object.feature_id)
        ? globalThis.String(object.feature_id)
        : "",
      featureTitle: isSet(object.featureTitle)
        ? globalThis.String(object.featureTitle)
        : isSet(object.feature_title)
        ? globalThis.String(object.feature_title)
        : "",
      summary: isSet(object.summary) ? globalThis.String(object.summary) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      featureAvailable: isSet(object.featureAvailable)
        ? globalThis.Boolean(object.featureAvailable)
        : isSet(object.feature_available)
        ? globalThis.Boolean(object.feature_available)
        : false,
    };
  },

  toJSON(message: PulseFeedItem): unknown {
    const obj: any = {};
    if (message.updateId !== "") {
      obj.updateId = message.updateId;
    }
    if (message.featureId !== "") {
      obj.featureId = message.featureId;
    }
    if (message.featureTitle !== "") {
      obj.featureTitle = message.featureTitle;
    }
    if (message.summary !== "") {
      obj.summary = message.summary;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.featureAvailable !== false) {
      obj.featureAvailable = message.featureAvailable;
    }
    return obj;
  },

  create(base?: DeepPartial<PulseFeedItem>): PulseFeedItem {
    return PulseFeedItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PulseFeedItem>): PulseFeedItem {
    const message = createBasePulseFeedItem();
    message.updateId = object.updateId ?? "";
    message.featureId = object.featureId ?? "";
    message.featureTitle = object.featureTitle ?? "";
    message.summary = object.summary ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.featureAvailable = object.featureAvailable ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
